import React from "react";
import './OurPeople.css';
import ourPeopleBg from '../assets/background/Our-People.jpg';
import fallon from '../assets/people/fallon.JPG';
import marty from '../assets/people/marty.png';
import chris from '../assets/people/chris.jpg';
import stephane from '../assets/people/stephane.jpg';
import brent from '../assets/people/brent.png';
import cathryne from '../assets/people/cathryne.jpg';
import kenFowler from '../assets/people/ken fowler.png';

const OurPeople = () => (
  <>
    {/* Hero Section */}
    <section className="people-hero">
      <div className="hero-background">
        <img src={ourPeopleBg} alt="" />
      </div>
      <div className="hero-overlay"></div>
      <div className="container">
        <div className="content">
          <div className="hero-text">
            <div className="padding">
              <h1>Our People</h1>
              <h2>Faculty & Alumni</h2>
              <p>Meet the dedicated faculty members and successful alumni who make the MPSc program a vibrant community of applied psychological scientists.</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* Faculty Section */}
    <section className="faculty">
      <div className="container">
        <div className="faculty-content">
          <div className="faculty-header">
            <h2>Faculty</h2>
            <p>Our distinguished faculty members bring expertise in applied psychological science and are committed to student success.</p>
          </div>
          
          <div className="faculty-grid">
            <div className="faculty-card">
              <div className="faculty-photo">
                <img src={cathryne} alt="Dr. Cathryn Button" />
              </div>
              <h3>Dr. Cathryn Button</h3>
              <p className="faculty-title">Professor</p>
              <p className="faculty-expertise">Research interests center on applied social psychology, quantitative methodology, and program evaluation. Their work includes investigating factors that influence replication success, modeling publication bias and questionable research practices, and analyzing study selection in meta-analysis. They also engage in evaluation research for community, health, and educational organizations, with projects addressing wellness in post-secondary settings, public engagement, patient advisory recruitment, and community needs assessments.</p>
            </div>
            
            <div className="faculty-card">
              <div className="faculty-photo">
                <img src={stephane} alt="Dr. Stéphane Dandeneau" />
              </div>
              <h3>Dr. Stéphane Dandeneau</h3>
              <p className="faculty-title">Professor</p>
              <p className="faculty-expertise">Stéphane has broad interests in social and socio-cultural psychology, as well as the underlying social cognitive processes that contribute to social resilience. Stephane's primary line of research investigates the links between self-esteem, social belonging and inclusion, mindfulness, self-compassion, social stress, and the attentional and cognitive processes involved in perpetuating psychological insecurities. Stéphane is Franco-Métis from the Red River Valley (present-day St-Boniface/Winnipeg).</p>
            </div>
            
            <div className="faculty-card">
              <div className="faculty-photo">
                <img src={marty} alt="Dr. Martin Day" />
              </div>
              <h3>Dr. Martin Day</h3>
              <p className="faculty-title">Associate Professor</p>
              <p className="faculty-expertise">In the societal cognition lab we primarily examine the psychological factors that help explain how people make sense of and respond to societal arrangements and problems. Take the case of inequality, which is linked to a variety of negative social and health outcomes. We study how people's beliefs about social mobility - the chances that people can change their social class - can lead them to then rationalize unequal conditions in society. We also examine how people perceive the problem of inequality and how they respond when faced with it.</p>
            </div>
            
            <div className="faculty-card">
              <div className="faculty-photo">
                {/* <i className="fas fa-user-graduate"></i> */}
                <img src={fallon} alt="Dr. Laura Fallon" />
              </div>
              <h3>Dr. Laura Fallon</h3>
              <p className="faculty-title">Assistant Professor</p>
              <p className="faculty-expertise">My research examines how information is elicited and used across investigative and courtroom settings. I focus on understanding and improving the interviewing tactics employed by police, with the goal of creating ethical, evidence-based approaches to questioning. By partnering with legal practitioners, I strive to bridge the gap between research and practice to promote a more effective and just legal system.</p>
            </div>
            
            <div className="faculty-card">
              <div className="faculty-photo ken-fowler-photo">
                <img src={kenFowler} alt="Dr. Ken Fowler" />
              </div>
              <h3>Dr. Ken Fowler</h3>
              <p className="faculty-title">Professor</p>
              <p className="faculty-expertise">Dr. Ken Fowler is the Director of Memorial's Student Wellness and Counselling Centre (SWCC), and a professor with the Department of Psychology. Dr. Fowler lectures in health and social psychology at the undergraduate and graduate levels, and conducts research focusing on social context predictors and consequences of various mental health issues such as anxiety and bipolar disorder, depression, eating disorders, and ADHD/ADD. Currently, Dr. Fowler is collaborating with Dr. Corey Keyes from Emory University exploring emotional, psychological, and social factors associated with university student positive mental health (PMH) and potential to flourish.</p>
            </div>
            
            <div className="faculty-card">
              <div className="faculty-photo">
                <img src={chris} alt="Dr. Chris Quinn-Nilas" />
              </div>
              <h3>Dr. Chris Quinn-Nilas</h3>
              <p className="faculty-title">Assistant Professor</p>
              <p className="faculty-expertise">Dr. Chris Quinn-Nilas is a professor in Social Psychology and runs the Love Lab. His research focuses on understanding relationship and sexual well-being, with current programs examining how adverse and traumatic experiences—such as childhood adversity, partner loss, and sexual assault—shape intimacy and romantic connection in adulthood. His work explores processes such as mindfulness, partner responsiveness, and self-compassion using advanced quantitative and qualitative methods. He also collaborates with the Sex Information and Education Council of Canada (SIECCAN) on projects of national relevance to sexual health and education.</p>
            </div>
            
            <div className="faculty-card">
              <div className="faculty-photo">
                <img src={brent} alt="Dr. Brent Snook" />
              </div>
              <h3>Dr. Brent Snook</h3>
              <p className="faculty-title">University Research Professor</p>
              <p className="faculty-expertise">Brent Snook is a University Research Professor in Psychology at Memorial University of Newfoundland. He holds a PhD in Psychology from the University of Liverpool, UK. His research pertains to the study of investigative practices (e.g., interviewing). Brent's work has led him to collaborate with academic and professional bodies around the world. In addition to implementing PEACE in Canada, his current body of work involves how people understand their legal rights and testing the effectiveness of various interviewing techniques for information gathering.</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* Alumni Section */}
    <section className="alumni">
      <div className="container">
        <div className="alumni-content">
          <div className="alumni-header">
            <h2>Alumni</h2>
            <p>Our graduates are making significant contributions across various sectors, demonstrating the impact of applied psychological science.</p>
          </div>
          
          <div className="alumni-stats">
            <div className="stat-card">
              <div className="stat-number">150+</div>
              <div className="stat-label">Graduates</div>
              <p>Since program inception</p>
            </div>
            
            <div className="stat-card">
              <div className="stat-number">99%</div>
              <div className="stat-label">Employment Rate</div>
              <p>Within 6 months of graduation</p>
            </div>
            
            <div className="stat-card">
              <div className="stat-number">25+</div>
              <div className="stat-label">Years</div>
              <p>Of program excellence</p>
            </div>
          </div>
          
          <div className="alumni-sectors">
            <h3>Alumni Career Sectors</h3>
            <div className="sectors-grid">
              <div className="sector-card">
                <div className="sector-icon">
                  <i className="fas fa-landmark"></i>
                </div>
                <h4>Government</h4>
                <p>Senior policy positions in federal and provincial government departments</p>
                <ul>
                  <li>Department of Health</li>
                  <li>Department of Transportation</li>
                  <li>Treasury Board</li>
                  <li>Statistics Canada</li>
                </ul>
              </div>
              
              <div className="sector-card">
                <div className="sector-icon">
                  <i className="fas fa-university"></i>
                </div>
                <h4>Academia</h4>
                <p>Faculty and administrative positions at universities and research institutions</p>
                <ul>
                  <li>Research Administration</li>
                  <li>Teaching & Mentoring</li>
                  <li>Program Development</li>
                  <li>Academic Leadership</li>
                </ul>
              </div>
              
              <div className="sector-card">
                <div className="sector-icon">
                  <i className="fas fa-briefcase"></i>
                </div>
                <h4>Private Sector</h4>
                <p>Partners and consultants in professional services and research firms</p>
                <ul>
                  <li>Goss-Gilroy Consulting</li>
                  <li>Market Quest</li>
                  <li>M5 Marketing</li>
                  <li>Research Development Corporation</li>
                </ul>
              </div>
              
              <div className="sector-card">
                <div className="sector-icon">
                  <i className="fas fa-hands-helping"></i>
                </div>
                <h4>Community Organizations</h4>
                <p>Leadership roles in non-profit and community service organizations</p>
                <ul>
                  <li>Stella's Circle</li>
                  <li>Community Services Council</li>
                  <li>Kids Lunch Program</li>
                  <li>Emmanuel House</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* Alumni Success Stories */}
    <section className="success-stories">
      <div className="container">
        <div className="stories-content">
          <div className="stories-header">
            <h2>Employer's Comments on the Program</h2>
            <p>Hear from our employers about their experience with our MPSc students.</p>
          </div>
          
          <div className="stories-grid">
            <div className="story-card">
              <div className="story-quote">
                <i className="fas fa-quote-left"></i>
                <p>"The program has been an important source of student (co-op) employees for our company, and also our main source of entry-level consultants in that we hired several for continuing employment following their work terms."</p>
              </div>
              <div className="story-author">
                <h4>Goss-Gilroy Consultants</h4>
                <p>Professional Services Firm</p>
              </div>
            </div>
            
            <div className="story-card">
              <div className="story-quote">
                <i className="fas fa-quote-left"></i>
                <p>"Having worked in private, non-profit, government and post-secondary education sectors I can attest to the utility of these program evaluation and research skills developed in the MPSc. program. There is simply no other educational program available locally that hones the evaluation skills that can answer questions about the efficacy of programs and policies in real-world settings with sufficient rigour."</p>
              </div>
              <div className="story-author">
                <h4>Centre for Collaborative Health Professional Education</h4>
                <p>Healthcare Education Institution</p>
              </div>
            </div>
            
            <div className="story-card">
              <div className="story-quote">
                <i className="fas fa-quote-left"></i>
                <p>"Yet without individuals contributing these specialized research and evaluation skills, it is difficult to measure and understand the impact that many natural science innovations have on the broader societal problems they were designed to address."</p>
              </div>
              <div className="story-author">
                <h4>Research Partner</h4>
                <p>Scientific Research Organization</p>
              </div>
            </div>
            
            <div className="story-card">
              <div className="story-quote">
                <i className="fas fa-quote-left"></i>
                <p>"Making the most of available resources and enhancing program effectiveness requires the knowledge, skills and abilities demonstrated by MPSc. students. The MPSc. program is also exemplary of public engagement for students, linking teaching and learning and research, with the needs of external partners."</p>
              </div>
              <div className="story-author">
                <h4>Office of Public Engagement, MUN</h4>
                <p>Memorial University of Newfoundland</p>
              </div>
            </div>
            
            <div className="story-card">
              <div className="story-quote">
                <i className="fas fa-quote-left"></i>
                <p>"We rely on students from the MPSc. program to help us achieve our research commitments. Their ability to think critically and apply current research leads to questions which challenge us to think differently. MPSc. students are a valuable asset to our organization, and I believe their skillsets are valuable to any organization interested in improving their outcomes."</p>
              </div>
              <div className="story-author">
                <h4>Department of Education, Government of NL</h4>
                <p>Provincial Government Department</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* Call to Action */}
    <section className="people-cta">
      <div className="container">
        <div className="cta-content">
          <h2>Learn More</h2>
          <p>Discover more about our program, admissions process, and frequently asked questions.</p>
          <div className="cta-buttons">
            <a href="/faq" className="btn secondary">Learn More</a>
          </div>
        </div>
      </div>
    </section>
  </>
);

export default OurPeople; 